/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 22.11.24
 *
 */

import VueAppContainer from "@/entry/VueAppContainer.js"
import App from '@/AppLight.vue'

console.log("createApp: setupAppGenogram.js, App = ", App)


if(!VueAppContainer.App){
	VueAppContainer.App = App
}

